// tslint:disable max-line-length triple-equals prefer-for-of
import React, { useEffect, useState } from 'react';
import ChartTrend from 'lqa-ui/lib/Applications/Admin/Components/ChartTrend';
import ListRankingItem from 'lqa-ui/lib/Applications/Admin/Components/ListRankingItem';
import ListRankingItemV2 from 'lqa-ui/lib/Applications/Admin/Components/ListRankingItemV2';
import Icon from 'lqa-ui/lib/Components/Icon';
import { getDepartmentApi } from '../../components/SelfAssessmentAssignDepartment/apiCaller';
import { getItem, setItem } from '../../utils/localStorage';
import { Collapse } from 'react-collapse';
import { useLocation, useNavigate } from 'react-router-dom';
import { pressAndHoldMenu } from '../../components/commons/PressAndHold';
import { assessments as assessmentApi } from '../Dashboard/apiCaller';
import {
  hotelBenchMarking,
  hotelScoresByDepartmentBenchmarking,
  benchmarkCustom,
  AssessmentSummaryAPI,
} from './../../requests/benchmarking';
import { StandardPerformaceSelector } from '../../components/commons/StandardPerformanceSelector/standardPerformanceSelector';
import { getComparedToAverageClassStyle } from '../../helpers/getComparedToAverageStyle';
import HotelAssessmentSelection from '../../components/commons/Header/HotelAssessmentSelection';
import Skeleton from 'react-loading-skeleton';
import { showErrorMessage } from '../../helpers/showMessage';
import { isUnauthorized } from '../../utils/common';
import PendingAssessment from '../commons/PendingAssessment';
import { gethasAssessment } from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import {
  BenchmarkingContainer,
  BenchmarkingReport,
  BlockShadow,
  BlockSpace,
  SubDepartmentUserTitle,
  BlockSpaceFlex,
} from './Benchmarking.styled';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { Body4, Headline1, Headline3 } from './../../app/common/typography';

const Benchmarking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const l: any = { ...location };
  const { state } = l;
  const compsetData = state.compsetData;
  const userData = getItem('user');
  const [toggle, setToggle] = useState([false]);
  const [selectedHotel, setSelectedHotel] = useState(getItem('selectedHotel'));
  const [selectedClient, setSelectedClient] = useState(getItem('selectedClient'));
  const [benchmarkingScores, setBenchmarkingScores] = useState([]);
  const [hotelScores, setHotelScores] = useState([] as any[]);
  const [isLoading, setIsLoading] = useState(false);
  const [standards, setStandards] = useState(
    state && state.standard ? state.standard : 'LQA'
  );
  const [performanceClassification, setPerformaceClassification] =
    useState('all');
  const [openPressAndHold, setOpenPressHold] = useState(false);
  const [tempData, setTempData] = useState<{ data: any[] } | undefined>(
    undefined
  );
  const isSubDepartmentUser =
    userData && userData.user && userData.user.userType === 'subDepartment';
  const [assessments, setAssessments] = useState<
    {
      stayStart: string;
      id: number;
    }[]
  >([]);
  const [apiData, setApiData] = useState<
    | {
      data: any[];
      overall: any;
    }
    | undefined
  >(undefined);
  const [selectedAssessment, setSelectedAssessment] = useState<string | undefined>(undefined);
  const [pressHoldData, setPressHoldData] = useState<any>({
    sourceCategoryId: null,
    visit: null,
  });
  const [selectedCompset, setSelectedCompset] = useState(state.selectedCompset);
  const [hasAssessment, setHasAssessment] = useState(gethasAssessment());

  useEffect(() => {
    setIsLoading(true);
    if (selectedAssessment) {
      if (standards === 'LQA') {
        hotelBenchMarking(selectedAssessment, performanceClassification)
          .then((res) => {
            setIsLoading(false);
          })
          .catch((err) => {
            showErrorMessage(
              'Could not find benchmark data',
              !isUnauthorized(err)
            );
          });
      }
    }
  }, [selectedAssessment, performanceClassification, standards]);

  useEffect(() => {
    setIsLoading(true);
    assessmentApi()
      .then((response) => {
        setAssessments(response);
        const selectedAssessmentIfAny = response.find(
          (bK) => bK.stayStart === state.selectedAssessment
        );
        const assess = response.find(
          (o) => o.stayStart === getItem('selectedAssessmentDate')
        )
          ? getItem('selectedAssessmentDate')
          : undefined;
        setSelectedAssessment(
          assess
            ? assess
            : selectedAssessmentIfAny
              ? selectedAssessmentIfAny.stayStart
              : response[0].stayStart
        );
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  }, [selectedHotel, selectedClient]);

  const handleCollapsible = (index) => {
    const collapse: any = [];
    Object.keys(collapse).forEach((key) => {
      collapse[key] = false;
    });
    if (!toggle[index]) {
      collapse[index] = true;
    } else {
      if (toggle[index] == true) {
        collapse[index] = false;
      } else {
        collapse[index] = true;
      }
    }
    setToggle(collapse);
  };

  useEffect(() => {
    if (state && state.hotelId) {
      const hotel = getItem('selectedHotel');
      setSelectedHotel(hotel ? hotel : state.hotelId);
      setItem('selectedHotel', hotel ? hotel : state.hotelId);
      setItem('selectedBrand', state.brandId);
    } else {
      const hotel = getItem('selectedHotel');
      setSelectedHotel(hotel ? hotel : userData.user.brands[0].hotels[0].id);
      setItem(
        'selectedHotel',
        hotel ? hotel : userData.user.brands[0].hotels[0].id
      );
      setItem('selectedBrand', userData.user.brands[0].id);
    }
  }, []);

  useEffect(() => {
    if (selectedAssessment) {
      AssessmentSummaryAPI(selectedAssessment)
        .then((res) => {
          setApiData(res);
          getDepartmentApi()
            .then((responseData) => {
              setTempData(responseData.data);
            })
            .catch((error) => {
              showErrorMessage(
                'Could not find template data',
                !isUnauthorized(error)
              );
            });
        })
        .catch((err) => {
          showErrorMessage(
            'Could not find Assessment Summary',
            !isUnauthorized(err)
          );
        });
    }
  }, [selectedAssessment]);

  useEffect(() => {
    if (standards !== 'LQA' && selectedAssessment) {
      setPerformaceClassification('all');
      benchmarkCustom(standards, selectedAssessment, performanceClassification)
        .then((res) => {
          const { scores, trends } = res;
          setHotelScores(scores);
          setBenchmarkingScores(trends);
          setIsLoading(false);
        })
        .catch((err) => {
          showErrorMessage(
            'Could not find benchmarking custom data',
            !isUnauthorized(err)
          );
        });
    } else {
      if (selectedAssessment) {
        hotelScoresByDepartmentBenchmarking(
          selectedAssessment,
          standards,
          performanceClassification,
          selectedCompset
        )
          .then((resp) => {
            const finalArray: any = [];
            const benchMarkByCategoryArr: any = [];
            const count = resp.data.filter((o) => o[1] === 'category').length;
            if (count > 1) {
              for (let i = 0; i < resp.data.length; i++) {
                const deptScore: any = [];
                deptScore.id = resp.data[i][0];
                deptScore.categoryType = resp.data[i][1];
                deptScore.title = resp.data[i][2];
                deptScore.parentId = resp.data[i][3];
                deptScore.rank = resp.data[i][4];
                deptScore.overallRank = resp.data[i][5];
                deptScore.low = resp.data[i][10];
                deptScore.high = resp.data[i][11];
                deptScore.average = resp.data[i][6];
                deptScore.current = resp.data[i][8];
                deptScore.previous = resp.data[i][9];
                deptScore.sourceTemplateCategoryId = resp.data[i][13];
                deptScore.visit = 1;
                if (
                  resp.data[i][1] === 'category' ||
                  resp.data[i][1] === 'overall'
                ) {
                  const bMark = {
                    name: resp.data[i][2],
                    val: resp.data[i][8],
                    lineVal: resp.data[i][4],
                    total: resp.data[i][5],
                    intent: getComparedToAverageClassStyle(
                      resp.data[i][6]
                        ? resp.data[i][8] - resp.data[i][6]
                        : undefined
                    ),
                  };
                  benchMarkByCategoryArr.push(bMark);
                }

                finalArray.push(deptScore);
              }
            } else {
              for (let i = 0; i < resp.data.length; i++) {
                const deptScore: any = [];
                deptScore.id = resp.data[i][0];
                deptScore.categoryType = resp.data[i][1];
                deptScore.title = resp.data[i][2];
                deptScore.parentId = resp.data[i][3];
                deptScore.rank = resp.data[i][4];
                deptScore.overallRank = resp.data[i][5];
                deptScore.low = resp.data[i][10];
                deptScore.high = resp.data[i][11];
                deptScore.average = resp.data[i][6];
                deptScore.current = resp.data[i][8];
                deptScore.previous = resp.data[i][9];
                deptScore.sourceTemplateCategoryId = resp.data[i][13];
                deptScore.visit = 1;
                if (
                  resp.data[i][1] === 'subCategory' ||
                  resp.data[i][1] === 'overall'
                ) {
                  const bMark = {
                    name: resp.data[i][2],
                    val: resp.data[i][8],
                    lineVal: resp.data[i][4],
                    total: resp.data[i][5],
                    intent: getComparedToAverageClassStyle(
                      resp.data[i][6]
                        ? resp.data[i][8] - resp.data[i][6]
                        : undefined
                    ),
                  };
                  benchMarkByCategoryArr.push(bMark);
                }

                finalArray.push(deptScore);
              }
            }
            setHotelScores(finalArray);
            setBenchmarkingScores(benchMarkByCategoryArr);
            setIsLoading(false);
          })
          .catch((err) => {
            showErrorMessage(
              'Could not find benchmark custom scores',
              !isUnauthorized(err)
            );
          });
      }
    }
  }, [
    selectedAssessment,
    standards,
    performanceClassification,
    selectedCompset,
  ]);

  if (!hasAssessment) {
    return (
      <PendingAssessment
        assessments={assessments}
        setAssessments={setAssessments}
        selectedHotel={selectedHotel}
        setSelectedHotel={setSelectedHotel}
        selectedClient={selectedClient}
        setSelectedClient={setSelectedClient}
        selectedAssessment={selectedAssessment}
        setSelectedAssessment={setSelectedAssessment}
        isSelectDate={true}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        lqaCompset={compsetData}
        selectedCompset={selectedCompset}
        setSelectedCompset={setSelectedCompset}
        hasAssessment={hasAssessment}
        setHasAssessment={setHasAssessment}
      />
    );
  }

  return (
    <>
      <HeaderContainer>
        <AppHeader title="Benchmarking" />
        <HotelAssessmentSelection
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          lqaCompset={compsetData}
          selectedCompset={selectedCompset}
          setSelectedCompset={setSelectedCompset}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </HeaderContainer>
      {hotelScores.length <= 0 ||
        !selectedAssessment ||
        !hotelScores ||
        isLoading ? (
        <BenchmarkingContainer>
          <div className="box-shadow d-block">
            <div className="m-10 mb-10">
              <Skeleton
                containerClassName="flex-1"
                height={35}
                borderRadius={5}
              />
              <Skeleton
                containerClassName="flex-1"
                height={20}
                borderRadius={5}
              />
              <div className="row-separater-skeleton mb-20">
                <Skeleton width={140} height={50} borderRadius={5} />
                <Skeleton width={140} height={50} borderRadius={5} />
              </div>
              <Skeleton
                containerClassName="flex-1"
                height={300}
                borderRadius={5}
              />
              <Skeleton
                containerClassName="flex-1"
                height={150}
                borderRadius={5}
              />
            </div>
          </div>
        </BenchmarkingContainer>
      ) : (
        <BenchmarkingContainer>
          <BenchmarkingReport>
            <Headline1>Hotel Benchmarking Report</Headline1>
            <Body4 color="battleShipGray">
              Data shows a comparison to competing hotels
            </Body4>
            {!isSubDepartmentUser && (
              <StandardPerformaceSelector
                standard={standards}
                setStandard={setStandards}
                selectedClient={selectedClient}
                selectedHotel={selectedHotel}
                selectedAssessment={selectedAssessment}
                performanceClassification={performanceClassification}
                setPerformaceClassification={setPerformaceClassification}
                isSelf={false}
              />
            )}
          </BenchmarkingReport>
          <BlockShadow>
            <ChartTrend data={benchmarkingScores} />
          </BlockShadow>
          {!isSubDepartmentUser ? (
            <BlockShadow>
              <BlockSpace>
                <ListRankingItem
                  title={hotelScores[0].title}
                  ranking={[hotelScores[0].rank, hotelScores[0].overallRank]}
                  low={hotelScores[0].low}
                  high={hotelScores[0].high}
                  average={hotelScores[0].average}
                  current={hotelScores[0].current}
                  intent={getComparedToAverageClassStyle(
                    hotelScores[0].current - (hotelScores[0].average || 0)
                  )}
                  layout={'standalone'}
                  percentageSign={true}
                />
              </BlockSpace>
            </BlockShadow>
          ) : (
            <></>
          )}
          <SubDepartmentUserTitle>
            <Headline3>
              {!isSubDepartmentUser ? 'By Department' : 'By Sub Department'}
            </Headline3>
          </SubDepartmentUserTitle>

          {hotelScores
            .filter((o: any) => o.categoryType == 'category')
            .map((category: any, index) => {
              const subCategory = hotelScores.filter(
                (o: any) =>
                  o.categoryType == 'subCategory' && o.parentId == category.id
              );
              const filterScore = hotelScores.filter(
                (hotelScores) =>
                  hotelScores.title.toLowerCase() ===
                  category.title.toLowerCase()
              );
              if (filterScore.length > 0) {
                return (
                  <>
                    <BlockShadow>
                      {!isSubDepartmentUser ? (
                        <BlockSpace
                          onClick={() => {
                            handleCollapsible(index);
                          }}
                        >
                          <ListRankingItem
                            title={filterScore[0].title}
                            ranking={[
                              filterScore[0].rank,
                              filterScore[0].overallRank,
                            ]}
                            low={filterScore[0].low}
                            high={filterScore[0].high}
                            average={filterScore[0].average}
                            current={filterScore[0].current}
                            percentageDifference={
                              filterScore[0].current - filterScore[0].previous
                            }
                            intent={getComparedToAverageClassStyle(
                              filterScore[0].current -
                              (filterScore[0].average || 0)
                            )}
                            layout={'standalone'}
                            percentageSign={true}
                          />
                        </BlockSpace>
                      ) : (
                        subCategory.map((subcat: any) => {
                          const filterSubCatScore = hotelScores.filter(
                            (hotelScores) =>
                              hotelScores.title.toLowerCase() ===
                              subcat.title.toLowerCase()
                          );
                          if (filterSubCatScore.length > 0) {
                            return (
                              <BlockShadow>
                                {
                                  <BlockSpaceFlex>
                                    <ListRankingItemV2
                                      title={filterSubCatScore[0].title.toLowerCase()}
                                      ranking={[
                                        filterSubCatScore[0].rank,
                                        filterSubCatScore[0].overallRank,
                                      ]}
                                      low={filterSubCatScore[0].low}
                                      high={filterSubCatScore[0].high}
                                      average={filterSubCatScore[0].average}
                                      current={filterSubCatScore[0].current}
                                      percentageDifference={
                                        filterSubCatScore[0].current -
                                        filterSubCatScore[0].previous
                                      }
                                      intent={getComparedToAverageClassStyle(
                                        filterSubCatScore[0].current -
                                        (filterSubCatScore[0].average || 0)
                                      )}
                                      layout={'standalone'}
                                      percentageSign={true}
                                    />
                                    <Icon
                                      kind="edit-diary"
                                      height={15}
                                      width={15}
                                      style={{ fill: 'black' }}
                                      onClick={() => {
                                        setPressHoldData(subcat);
                                        setOpenPressHold(true);
                                      }}
                                    />
                                  </BlockSpaceFlex>
                                }
                              </BlockShadow>
                            );
                          } else {
                            return <></>;
                          }
                        })
                      )}
                      <Collapse isOpened={toggle[index]}>
                        {subCategory.map((subcat: any) => {
                          const filterSubCatScore = hotelScores.filter(
                            (hotelScores) =>
                              hotelScores.title.toLowerCase() ===
                              subcat.title.toLowerCase()
                          );
                          if (filterSubCatScore.length > 0) {
                            return (
                              <BlockShadow>
                                {
                                  <BlockSpaceFlex>
                                    <ListRankingItemV2
                                      title={filterSubCatScore[0].title.toLowerCase()}
                                      ranking={[
                                        filterSubCatScore[0].rank,
                                        filterSubCatScore[0].overallRank,
                                      ]}
                                      low={filterSubCatScore[0].low}
                                      high={filterSubCatScore[0].high}
                                      average={filterSubCatScore[0].average}
                                      current={filterSubCatScore[0].current}
                                      percentageDifference={
                                        filterSubCatScore[0].current -
                                        filterSubCatScore[0].previous
                                      }
                                      intent={getComparedToAverageClassStyle(
                                        filterSubCatScore[0].current -
                                        (filterSubCatScore[0].average || 0)
                                      )}
                                      layout={'standalone'}
                                      percentageSign={true}
                                    />
                                    <Icon
                                      kind="edit-diary"
                                      height={15}
                                      width={15}
                                      style={{ fill: 'black' }}
                                      onClick={() => {
                                        setPressHoldData(subcat);
                                        setOpenPressHold(true);
                                      }}
                                    />
                                  </BlockSpaceFlex>
                                }
                              </BlockShadow>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                      </Collapse>
                    </BlockShadow>
                  </>
                );
              } else {
                return <></>;
              }
            })}
        </BenchmarkingContainer>
      )}
      {pressAndHoldMenu(
        pressHoldData,
        setOpenPressHold,
        openPressAndHold,
        selectedAssessment,
        tempData,
        apiData,
        navigate
      )}
    </>
  );
};

export default Benchmarking;
